import { render, staticRenderFns } from "./Render-Content.vue?vue&type=template&id=f200791c&"
import script from "./Render-Content.vue?vue&type=script&lang=js&"
export * from "./Render-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports